// The chosen integration is also added as the first team member (round robin stays off).
export function createDefaultCalendarConfig(integrationId, { memberName = '' } = {}) {
  return {
    integration_id: integrationId,
    slot_length: 30,
    available_timeslots: {
      monday: { active: true, start: '09:00', end: '17:00' },
      tuesday: { active: true, start: '09:00', end: '17:00' },
      wednesday: { active: true, start: '09:00', end: '17:00' },
      thursday: { active: true, start: '09:00', end: '17:00' },
      friday: { active: true, start: '09:00', end: '17:00' },
      saturday: { active: false, start: '09:00', end: '17:00' },
      sunday: { active: false, start: '09:00', end: '17:00' },
    },
    buffer_before: 0,
    buffer_after: 0,
    minimum_advance_booking_hours: 0.5,
    meeting_title: '',
    meeting_body: '',
    add_google_meet_link: false,
    add_address_to_meeting_item: false,
    meeting_address: '',
    round_robin_enabled: false,
    round_robin_config: {
      integrations: integrationId
        ? [{ integration_id: integrationId, name: memberName, locations: [] }]
        : [],
    },
    locations: [],
  };
}
